import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { FamilyEvent } from './FamilyEvent.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class FamilyRegistration extends MongoEntity {
  static override _class = 'FamilyRegistration';
  static override _collectionName = 'family-registrations';

  @validate(nonOptional())
  @Field(type => String)
  public eventID: Maybe<string>;

  @DataLoadedField(type => FamilyEvent, ({ eventID }) => eventID)
  public event: Maybe<FamilyEvent>;

  @Field(type => String)
  public vorname: Maybe<string>;

  @Field(type => String)
  public nachname: Maybe<string>;

  @Field(type => String)
  public email: Maybe<string>;

  @Field(type => String)
  public sprachbedarf: Maybe<string>;
}
